import { FiltersActions } from 'store/reducers/filters';

export function* changeFiltersSaga(action: ReturnType<typeof FiltersActions.marketplace.changeFilters>) {
	const { callback } = action.payload;
	if (callback) {
		yield callback();
	}
}
